import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { env } from 'src/utils';
import { initIntercom } from 'src/utils/intercom';
import '../css/index.css';
import * as i18n from '../i18n';
import store from '../store';
import { ThemeProviders } from './utils/ThemeProviders';
import ActivityMonitor from './ActivityMonitor';
import { InternalRouting } from './pages';

i18n.initialise();

const App = () => {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  if (env.REACT_APP_ENVIRONMENT_NAME !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`Running on environment: ${env.REACT_APP_ENVIRONMENT_NAME}`);
  }

  const shouldInitializeIntercom =
    env.REACT_APP_ENVIRONMENT_NAME === 'production' ||
    env.REACT_APP_ENVIRONMENT_NAME === 'dev';

  if (shouldInitializeIntercom) {
    initIntercom({
      app_id: env.REACT_APP_INTERCOM_APP_ID,
    });
  }
  return (
    <Provider store={store}>
      <BrowserRouter>
        <CompatRouter>
          <ThemeProviders>
            <QueryClientProvider client={queryClient}>
              <div className="root">
                <ReactQueryDevtools initialIsOpen={false} />
                <ActivityMonitor />
                <Switch>
                  <Route component={InternalRouting} />
                </Switch>
              </div>
            </QueryClientProvider>
          </ThemeProviders>
        </CompatRouter>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
